import {
  getVariantContent,
  IVariationCollectionType,
  useContentful
} from '@pcln/contentful-components'
import useSeti from '@/hooks/useSeti'
import isContentIVariationCollectionType from '@/shared-utils/is-content-ivariation-collection-type'

export default function useContentfulVariation<T = unknown>(
  fieldName: string,
  shouldFireImpression = true
): T | null {
  const content = useContentful(fieldName) as
    | T
    | IVariationCollectionType
    | undefined
  const isVariantCollection = isContentIVariationCollectionType<T>(content)
  const setiName = useSeti(
    isVariantCollection ? content.experimentName : '',
    shouldFireImpression &&
      isVariantCollection &&
      content.experimentName !== undefined
  )
  return isVariantCollection
    ? (getVariantContent(setiName, content) as T)
    : content ?? null
}
